import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, HashRouter, Redirect } from "react-router-dom";

import Cookie from "js-cookie";

import { Helmet } from "react-helmet";

import Footer from "./components/footer";
import Venta from "./pages/venta";

import { RootState } from './utils/interface';
import { AppDispatch } from "./store";
import Cookies from 'js-cookie';
import Home from './pages/home';

import CacheBuster from './CacheBuster';
import NavBar from './pages/home/navbar';
import Terms from './pages/terms';
import Privacidad from './pages/privacidad';

const App = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    if (!auth?.user) {
      if (Cookie.getJSON("user")) {
        dispatch({
          type: 'SET_USER',
          payload: Cookie.getJSON("user"),
        });
      }
    }

    if (!auth?.token) {
      if (Cookie.getJSON("user")) {
        dispatch({
          type: 'SET_TOKEN',
          payload: Cookies.get('token'),
        });
      }
    }
  }, []);

  return (
   <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }: {
        loading: boolean,
        isLatestVersion: boolean,
        refreshCacheAndReload: Function,
      }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }

        return (
          <HashRouter>
            <Helmet>
              <title>Campo Mercado</title>
              <meta name="description" content="Comercialización de ganado online. Ofrecemos un sistema de venta seguro, transparente y sencillo." />
              <meta property="og:description" content="Comercialización de ganado online. Ofrecemos un sistema de venta seguro, transparente y sencillo." />
            </Helmet>
            <Switch>
              {/* <Route path="/venta">
                <>
                  <div className="wrapper">
                    <div className="content">
                      <NavBar mode="WhiteWithShadow" buttons={true} isLoggedIn={auth?.user ? true : false} user={auth?.user} />
                      <Venta isLoggedIn={auth?.user ? true : false} />
                      <Footer />
                    </div>
                  </div>
                </>
              </Route> */}
              <Route path="/terms">
                <NavBar mode="WhiteWithShadow" buttons={true} isLoggedIn={auth?.user ? true : false} user={auth?.user} />
                <Terms />
                <Footer />
              </Route>
              <Route path="/privacidad">
                <NavBar mode="WhiteWithShadow" buttons={true} isLoggedIn={auth?.user ? true : false} user={auth?.user} />
                <Privacidad />
                <Footer />
              </Route>
              <Route path="/">
                <Home isLoggedIn={auth?.user ? true : false} user={auth?.user} />
              </Route>
              <Redirect to="/" />
            </Switch>
          </HashRouter>
        );
      }}
    </CacheBuster>
  );
};

export default App;
